export enum StorageKeys {
  REPORTS_QUEUE = `REPORTS_QUEUE`,
  APP_BANNER_DISMISSED = `APP_BANNER_DISMISSED`,
  APP_UPDATE_DISMISSED = `APP_UPDATE_DISMISSED`,
  SEARCH_VOICE_LANGUAGE = `SEARCH_VOICE_LANGUAGE_KEY`,
  DRAGGABLE_STATE = `DRAGGABLE_STATE`,
  DRIVERS_STATE = `DRIVERS_STATE`,
  DRIVERS_SCANNING_DEVICE = `DRIVERS_SCANNING_DEVICE`,
  SELECTED_ROUTE = `SELECTED_ROUTE`,
  CREATE_STOPS_INITIAL_LOCATION = `CREATE_STOPS_INITIAL_LOCATION`,
  DRIVERS_MAPS_APPLICATION = `DRIVERS_MAPS_APPLICATION`,
  DRIVERS_SCAN_CODE_READER = `DRIVERS_SCAN_CODE_READER`,
  OTP_METHOD = `OTP_METHOD`,
}
